import { isPlatformBrowser } from '@angular/common';
import { Directive, HostListener, inject, PLATFORM_ID } from '@angular/core';
@Directive({
    selector: '[specialIsAlphaNumeric]',
    standalone: false
})
export class SpecialCharacterDirective {
  readonly regexStrNum = '^[-a-zA-Z0-9]*$';
  platformId = inject(PLATFORM_ID); 
  // Check for keypress event
  @HostListener('keypress', ['$event'])
  onKeyPress(event) {
    return new RegExp(this.regexStrNum).test(event.key);
  }

  // Check for copy-paste
  @HostListener('paste', ['$event'])
  blockPaste(event: ClipboardEvent) {
    this.validateFields(event);
  }

  validateFields(event: ClipboardEvent) {
    event.preventDefault();
    const pasteData = event.clipboardData.getData('text/plain').replace(/[^-a-zA-Z0-9]/g, '');
    if (isPlatformBrowser(this.platformId)) {
    document.execCommand('insertHTML', false, pasteData);
    }
  }
}
